module.exports = __webpack_public_path__ + "img/graphic-5.5e7fa891.png";